import React from "react";
import { useUsersController } from "./useUsersController";
import { UserSearch } from "./components/UserSearch";
import { UsersTable } from "./components/UsersTable";

export const Users = () => {
  const controller = useUsersController();

  if (controller.loading) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <UserSearch
        searchQuery={controller.searchQuery}
        handleSearch={controller.handleSearch}
      />

      <UsersTable
        users={controller.filteredUsers}
        changeUserRole={controller.changeUserRole}
      />
    </div>
  );
};
